import { Button, Grid } from '@mui/material';
import {
	accountTransitionSet,
	TransitionStatus,
} from '@Services/accountTransition';
import { AccountTransitionCache } from '@Utils/cloudos/AccountTransitionCache';
import React from 'react';

export const AccountTransitionControls = () => {
	const transitionAccount = async (transitionStatus: TransitionStatus) => {
		const accChecker = AccountTransitionCache.getInstance();
		await accountTransitionSet({ status: transitionStatus });
		accChecker.reset();
		await accChecker.isTransitionAccount();
	};

	const onButtonClickToLegacy = () => {
		transitionAccount('legacy');
	};

	const onButtonClickToNew = () => {
		transitionAccount('new');
	};

	return (
		<>
			<Grid container spacing={2}>
				<Grid item xs={6}>
					<Button
						data-cy="transition-to-legacy"
						variant="contained"
						fullWidth
						onClick={() => onButtonClickToLegacy()}>
						{'to legacy'}
					</Button>
				</Grid>

				<Grid item xs={6}>
					<Button
						data-cy="transition-to-new"
						variant="contained"
						fullWidth
						onClick={() => onButtonClickToNew()}>
						{'to new'}
					</Button>
				</Grid>
			</Grid>
		</>
	);
};
